import { GlobalProvider } from './context/GlobalProvider';
import './local';
import RouteComponent from './routes/Routes';

function App() {
  return (
    <GlobalProvider>
      <RouteComponent />
    </GlobalProvider>
  );
}

export default App;
